import Icon from 'choerodon-ui/lib/icon';
export default Icon;
